"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipModelExperience = void 0;
/**
 * @deprecated - still used by old mobile app version
 */
var TipModelExperience;
(function (TipModelExperience) {
    // ! DEPRECATED
    TipModelExperience["Model1"] = "Model1";
    // ! DEPRECATED
    TipModelExperience["ModelA"] = "ModelA";
    // ! DEPRECATED
    TipModelExperience["ModelB"] = "ModelB";
    TipModelExperience["ModelC"] = "ModelC";
    TipModelExperience["ModelD"] = "ModelD";
    TipModelExperience["ModelE"] = "ModelE";
})(TipModelExperience || (exports.TipModelExperience = TipModelExperience = {}));
